import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApi, RequestType } from '@kapi';
import { EnvironmentVariablesService } from '@kenv';
import { Traits } from '@kp/traits/traits.model';
import { DataStoreService } from '@kservice';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class TraitsApi extends BaseApi {
  constructor(
    private _client: HttpClient,
    public dataStoreService: DataStoreService,
    private _environmentVariablesService: EnvironmentVariablesService
  ) {
    super(_client, dataStoreService, _environmentVariablesService);
  }

  async getTraits(): Promise<Traits> {
    const url = this.buildUrl('/traits', true);

    return this.performRequest<Traits>(RequestType.GET, url, { includeToken: true })
      .pipe(
        map((response: HttpResponse<Traits>): Traits => {
          if (response && response.ok) {
            return new Traits().deserialize(response.body);
          }
          return null;
        }),
        catchError((): Observable<Traits> => of(new Traits(null)))
      )
      .toPromise()
      .catch((error) => {
        console.warn(`Error getting user traits: ${JSON.stringify(error)}`);
        return null;
      });
  }
}
